import { QueryClient } from "@tanstack/react-query";

import { invalidateReviewItems } from "@components/QaReview/hooks/reviewMutations";

/** Sent by the API when someone else changes a report's Team Review comments. Never stored, so the bell has nothing to show for it. */
export const REVIEW_COMMENTS_CHANGED = "REVIEW_COMMENTS_CHANGED";

type BroadcastNotification = { notificationType?: string; payload?: { reportId?: string } | string | null } | null;

/**
 * Reloads the named report's review items, which refetches only if that report's review panel is open.
 * Takes the notification socket message's `payload.message`; true when it was this signal, so the bell skips it.
 */
export const handleReviewCommentsChanged = (message: string | undefined, queryClient: QueryClient): boolean => {
  // Only this signal is parsed, so every other NEW message reaches the bell exactly as before.
  if (typeof message !== "string" || !message.includes(REVIEW_COMMENTS_CHANGED)) return false;
  const notification = JSON.parse(message) as BroadcastNotification;
  if (notification?.notificationType !== REVIEW_COMMENTS_CHANGED) return false;
  const reportId = typeof notification.payload === "object" ? notification.payload?.reportId : undefined;
  if (reportId) void invalidateReviewItems(queryClient, reportId);
  return true;
};
